import {
  Box,
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import CabinCreateInWizardForm from "pages/vending/machine/create/CabinCreateInWizardForm";
import CreateMachineForm from "pages/vending/machine/create/CreateMachineForm";
import CreateMachineUserForm from "pages/vending/machine/create/CreateMachineUserForm";
import DisplayConfigInWizard from "pages/vending/machine/create/DisplayConfigInWizard";
import PartitionCreateWizardForm from "pages/vending/machine/create/PartitionCreateWizardForm";
import PaymentInWizard from "pages/vending/machine/create/PaymentInWizard";
import TrayCreateInWizardForm from "pages/vending/machine/create/TrayCreateInWizardForm";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearConfig } from "store/reducers/machineConfig";
import { clearPayments } from "store/reducers/payments";
import { clearMachineState, clearMachineUser } from "store/reducers/vending";

const MachineCreateWizard = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [trayStepCompleted, setTrayStepCompleted] = React.useState(false);
  const [partitionStepCompleted, setPartitionStepCompleted] =
    React.useState(false);
  const [paymentStepCompleted, setPaymentStepCompleted] = React.useState(false);
  const [displayConfigCompleted, setDisplayConfigCompleted] =
    React.useState(false);
  const dispatch = useDispatch();
  const vendingState = useSelector((state) => state.vending);
  useEffect(() => {
    return () => {
      dispatch(clearMachineState());
      dispatch(clearMachineUser());
      dispatch(clearPayments());
      dispatch(clearConfig());
    };
  }, []);

  const handleNext = useCallback(() => {
    console.log("Next");
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, []);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    console.log("Skip");
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  useEffect(() => {
    if (vendingState.createMachineSuccess) {
      if (handleNext) {
        handleNext();
      }
    }
  }, [handleNext, vendingState.createMachineSuccess]);
  return (
    <Box>
      <Typography variant="h5" color="gray">
        Welcome to machine creation wizard
      </Typography>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        sx={{ marginTop: 1 }}
      >
        <Step completed={Boolean(vendingState.currentMachine)}>
          <StepLabel>
            <Typography variant="h6">Add basic details</Typography>
          </StepLabel>
          <StepContent>
            <CreateMachineForm handleNext={handleNext} />
          </StepContent>
        </Step>
        <Step completed={Boolean(vendingState.currentMachine?.user)}>
          <StepLabel>
            <Typography variant="h6">Assign auth details</Typography>
          </StepLabel>
          <StepContent>
            <CreateMachineUserForm
              handleNext={handleNext}
              handleSkip={handleSkip}
            />
          </StepContent>
        </Step>
        <Step completed={vendingState.createMultipleCabinSuccess}>
          <StepLabel>
            <Typography variant="h6">Add cabins</Typography>
          </StepLabel>
          <StepContent>
            <Box sx={{ mb: 2 }}>
              <CabinCreateInWizardForm
                handleNext={handleNext}
                handleSkip={handleSkip}
                machine={vendingState.currentMachine}
              />
            </Box>
          </StepContent>
        </Step>
        <Step completed={trayStepCompleted}>
          <StepLabel>
            <Typography variant="h6">Add trays</Typography>
          </StepLabel>
          <StepContent>
            <TrayCreateInWizardForm
              handleNext={handleNext}
              handleSkip={handleSkip}
              trayStepCompleted={trayStepCompleted}
              setTrayStepCompleted={setTrayStepCompleted}
              machine={vendingState.currentMachine}
            />
          </StepContent>
        </Step>
        <Step completed={partitionStepCompleted}>
          <StepLabel>
            <Typography variant="h6">Add partitions</Typography>
          </StepLabel>
          <StepContent>
            <Box sx={{ mb: 2 }}>
              <PartitionCreateWizardForm
                handleNext={handleNext}
                handleSkip={handleSkip}
                trayStepCompleted={trayStepCompleted}
                partitionStepCompleted={partitionStepCompleted}
                setPartitionStepCompleted={setPartitionStepCompleted}
              />
            </Box>
          </StepContent>
        </Step>
        <Step completed={paymentStepCompleted}>
          <StepLabel>
            <Typography variant="h6">Assign payments</Typography>
          </StepLabel>
          <StepContent>
            <PaymentInWizard
              handleNext={handleNext}
              handleSkip={handleSkip}
              paymentStepCompleted={paymentStepCompleted}
              setPaymentStepCompleted={setPaymentStepCompleted}
              machine={vendingState.currentMachine}
            />
          </StepContent>
        </Step>
        <Step completed={displayConfigCompleted}>
          <StepLabel>
            <Typography variant="h6">Add display configurations</Typography>
          </StepLabel>
          <StepContent>
            <Box sx={{ mb: 2 }}>
              <DisplayConfigInWizard
                currentMachine={vendingState.currentMachine}
                handleSkip={handleSkip}
                handleNext={handleNext}
                setDisplayConfigCompleted={setDisplayConfigCompleted}
              />
            </Box>
          </StepContent>
        </Step>
      </Stepper>
    </Box>
  );
};

export default MachineCreateWizard;
